import type { Theme } from '@mui/material/styles';
import {
    Border,
    Spacing,
} from '@uipath/apollo-core';

export const flatActionButtonStyle = (theme: Theme) => ({
    background: 'none',
    border: 'none',
    cursor: 'pointer',
    padding: `${Spacing.SpacingXs} ${Spacing.SpacingS}`,
    borderRadius: Border.BorderRadiusM,
    color: theme.palette.semantic.colorPrimary,
    '&:hover': { backgroundColor: theme.palette.semantic.colorBackgroundHover },
    display: 'flex',
    alignItems: 'center',
    gap: Spacing.SpacingXs,
    '&:disabled': {
        opacity: 0.4,
        cursor: 'not-allowed',
        '&:hover': { backgroundColor: 'transparent' },
    },
});
